import React from "react";
import "../styles/Careers.css";
import { FaArrowRightLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const Careers = () => {
  const navigate = useNavigate();

  return (
    <div className="C_section">
      <div className="C_section_one animate-down">
        <section className="C_section_one_1">
          <h6>Careers</h6>
          <h1>Join Our Global Team at Arshil</h1>
          <p>
            At Arshil, we're not just building technology solutions; we're
            building a future where talented individuals thrive in a
            collaborative and supportive environment. If you're passionate about
            technology, driven by innovation, and eager to make a global impact,
            you've come to the right place.
          </p>
          <button
            onClick={() => navigate("/contact")}
            className="C_section_one_1_button"
          >
            Join Our Team
            <FaArrowRightLong className="C_arrow" />
          </button>
        </section>
        <section className="C_section_one_2">
          <img src="images/C_sec1_img1.png" alt="" />
        </section>
      </div>

      {/* Section 2 */}

      <div className="C_section_two">
        <section className="C_section_two_1">
          <h1>Our Core Values</h1>
          <p>
            At Arshil, our core values are more than just words; they are the
            principles that shape our daily interactions and drive our decisions
          </p>
        </section>

        <section className="C_section_two_2_container">
          <section className="C_section_two_2">
            <section className="C_section_two_2_1 animate-left">
              <img src="images/C_sec2_img1.png" alt="" />
            </section>

            <section className="C_section_two_2_2 animate-right">
              <h4>People</h4>
              <p>
                You are our greatest asset. We foster a supportive environment
                where you can thrive and reach your full potential.
              </p>
            </section>
          </section>
          <section className="C_section_two_2">
            <section className="C_section_two_2_1 animate-left">
              <img src="images/C_sec2_img2.png" alt="" />
            </section>

            <sectio className="C_section_two_2_2 animate-right">
              <h4>Technology</h4>
              <p>
                We are committed to staying at the forefront of technology.
                You'll have the opportunity to work with the latest tools and
                contribute to innovative solutions.
              </p>
            </sectio>
          </section>
          <section className="C_section_two_2">
            <section className="C_section_two_2_1 animate-left">
              <img src="images/C_sec2_img3.png" alt="" />
            </section>

            <sectio className="C_section_two_2_2 animate-right">
              <h4>Innovation</h4>
              <p>
                We encourage creativity and new ideas. We are always exploring
                ways to push boundaries and solve challenges in unique and
                meaningful ways
              </p>
            </sectio>
          </section>
          <section className="C_section_two_2">
            <section className="C_section_two_2_1 animate-left">
              <img src="images/C_sec2_img4.png" alt="" />
            </section>

            <section className="C_section_two_2_2 animate-right">
              <h4>Doing the Right Thing</h4>
              <p>
                This mantra is our guiding light. We are committed to acting
                with integrity and making ethical decisions in all that we do
              </p>
            </section>
          </section>
        </section>
      </div>

      {/* Section 3 */}

      <div className="C_section_three animate-up">
        <h1>Life at Arshil</h1>
        <p>
          At Arshil, we understand that a flexible work environment is key to
          attracting and retaining top talent. While our physical office in
          Hyderabad, India, offers a collaborative space for local team members,
          we embrace a remote-first approach, empowering you to manage your work
          and schedule effectively while collaborating globally. We are focused
          on results and building a conducive environment where open
          communication is encouraged, and you can readily connect with your
          manager or supervisor without hesitation.
        </p>
      </div>

      {/* Section 4 */}

      <div className="C_section_four">
        <section className="C_section_four_one animate-left">
          <img src="images/C_sec4_img1.png" alt="" />
        </section>

        <section className="C_section_four_two animate-right">
          <h2>Perks and Benefits at Arshil</h2>
          <section className="C_section_four_two_1">
            <ul>
              <li>
                <span className="C_section_four_two_1_span">
                  Competitive Salary:
                </span>{" "}
                We offer salaries that are competitive within the industiry,
                recognizing and productivity. Work from where you thrive.
              </li>
              <li>
                <span className="C_section_four_two_1_span">
                  Hybrid Work Model:
                </span>{" "}
                We offer a flexible work environment that blends remote and
                onsite work, enabling seamless collaboration while maintaining
                productivity and work-life balance.
              </li>
              <li>
                <span className="C_section_four_two_1_span">
                  Paid Time Off (PTO) :
                </span>{" "}
                Paid Time Off (PTO): Take the time you need to rest, recharge,
                and attend to personal matters.
              </li>
              <li>
                <span className="C_section_four_two_1_span">
                  Performance-Based Compensation:
                </span>{" "}
                 Your hard work and achievements are directly recognized and
                rewarded. 
              </li>
              <li>
                <span className="C_section_four_two_1_span">
                  Professional Development:
                </span>{" "}
                 We invest in your growth through various opportunities to
                enhance your skills and advance your career.
              </li>
              <li>
                <span className="C_section_four_two_1_span">
                  Yearly Team Meetup:
                </span>{" "}
                 Connect with colleagues, build relationships, and foster
                collaboration during our annual get-together.
              </li>
              <li>
                <span className="C_section_four_two_1_span">
                  On-site location:
                </span>{" "}
                 Our physical office in Hyderabad, India, provides a space for
                in-person collaboration, team meetings, and social interaction.
              </li>
              <li>
                <span className="C_section_four_two_1_span">
                  Flexible Work Arrangements:
                </span>{" "}
                 We trust you to manage your time effectively and prioritize
                results. We focus on impact and results.
              </li>
            </ul>
          </section>
        </section>
      </div>
    </div>
  );
};

export default Careers;
